<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" id="accountOwnerHome"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">My Accounts</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked);"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
      </div>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'bankAccountInfo'}" class="row hide-sec">
      <div class="col">
        <!--Contact information-->
        <div  class="inner-box">
          <div class="row mt-3">

            <div class="col-md-4 required">

              <div *ngIf="user.role !=='ROLE_USER'" class="form-group required">
                <label class="control-label" for="accountType">Account Type</label>
                <select id="accountTypeId" class="form-control" [(ngModel)]="bank.accountType" (blur)="typeAccountType()"
                        [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':accountTypeError}" required>
                  <option *ngFor="let c of accountTypeList" [ngValue]="c.config">{{c.config}}</option>
                </select>
                <div [hidden]="!accountTypeError" class="invalid-feedback d-block shift-invalid-login" id="accountType">
                  {{accountTypeError}}
                </div>
              </div>
            </div>
            <div class="col-md-4 required">

              <div *ngIf="user.role !=='ROLE_USER'" class="form-group required">
                <label class="control-label" for="accountName">Account Name</label>
                <input (blur)="typeAccountName()"  [ngClass]="{'is-invalid':accountNameError}"
                       [(ngModel)] ="bank.accountName" [ngModelOptions] ="{standalone:true}"
                       class="form-control"
                       id="accountName" required type="text" onkeypress='return event.charCode >= 90 && event.charCode <= 120 || event.charCode >= 65 && event.charCode <=90'>
                <div [hidden]="!accountNameError" class="invalid-feedback d-block shift-invalid-login"
                     id="accountNameError">{{accountNameError}}
                </div>
              </div>
            </div>

            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="accountNo">Account Number</label>
                <input (blur)="typeAccountNumber()"  [(ngModel)]="bank.accountNumber" [ngModelOptions] = "{standalone :true}"  [ngClass]="{'is-invalid':accountNumberError}" class="form-control"
                       id="accountNo" required type="text" appOnlyNumbers>
                <div [hidden]="!accountNumberError" class="invalid-feedback d-block shift-invalid-login" id="accountNumberError">
                  {{accountNumberError}}
                </div>
              </div>
            </div>


          </div>
          <div [ngStyle]="{'padding-left':(user.role ==='ROLE_USER')?'0px':'0px'}" class="row">

            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="bankName">Bank Name</label>
                <input (blur)="typeBankName()" [(ngModel)] = "bank.bankName" [ngModelOptions]="{standalone:true}" [ngClass]="{'is-invalid':bankNameError}"
                       class="form-control" id="bankName" maxlength="30"
                       required type="text" onkeypress='return event.charCode >= 90 && event.charCode <= 120 || event.charCode >= 65 && event.charCode <=90'>

                <div [hidden]="!bankNameError" class="invalid-feedback d-block shift-invalid-login" id="mobileError">
                  {{bankNameError}}
                </div>
              </div>
            </div>

            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="ifsc">IFSC Code</label>
                <input (blur)="typeIfscCode()" [(ngModel)]="bank.ifscCode" [ngModelOptions] ="{standalone: true}" [ngClass]="{'is-invalid':ifscError}"
                       class="form-control" id="ifsc" maxlength="15"
                       required type="text" >

                <div [hidden]="!ifscError" class="invalid-feedback d-block shift-invalid-login" id="ifscError">
                  {{ifscError}}
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group w-50 verified" *ngIf="bank?.accountVerified === 'N'">Not verified</div>
              <div class="form-group w-50 verified1" *ngIf="bank?.accountVerified === 'Y'">Verified</div>
            </div>

          </div>

          <div *ngIf="user.role !=='ROLE_USER'" class="mt-3">
            <div class="col text-right">
              <button class="btn btn-orange" (click)="manageBankAccount()" type="submit">Save</button>

            </div>
          </div>
        </div>
        <!--End Contact information-->
        <!--Delete information-->

        <!-- End Delete information-->
      </div>

    </div>

    <div class="hide-sec" [ngClass]="{'show-sec': tabClicked === 'address'}">
      <div class="inner-box d-none d-sm-block">
        <div class="row">
          <div class="col">
            <div>
              <h2 class="text-black mb-3">Address</h2>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group ">
                    <label class="control-label" for="address1">Address 1</label>
                    <input type="text" id="address1" [(ngModel)]="viewSeller.address1" class="form-control"
                           [ngModelOptions]="{standalone: true}" required disabled>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" for="address2">Address 2</label>
                    <input type="text" id="address2" [(ngModel)]="viewSeller.address2" class="form-control"
                           [ngModelOptions]="{standalone: true}" required disabled>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group ">
                    <label class="control-label" for="city">City</label>
                    <input type="text" id="city" [(ngModel)]="viewSeller.city" class="form-control"
                           [ngModelOptions]="{standalone: true}" required disabled>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group ">
                    <label class="control-label">State</label>
                    <input type="text" id="State" [(ngModel)]="viewSeller.state" class="form-control"
                           [ngModelOptions]="{standalone: true}" required disabled>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group ">
                    <label class="control-label" for="accountZipAlt">Zip</label>
                    <input type="text" id="accountZipAlt" [(ngModel)]="viewSeller.zipCode" class="form-control"
                           [ngModelOptions]="{standalone: true}" required disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hide-sec" [ngClass]="{'show-sec': tabClicked === 'returnSettings'}">
      <div>
        <section>
          <form>
            <div class="row">
              <div class="col">
                <div class="inner-box">
                  <h2>Set An Eligibility Frame</h2>
                  <div class="row mt-3">
                    <div class="col-md-8">
                      <div>
                        Items must be returned within the timeline established by you. Please note that time period
                        begins when
                        Customer places order, not when Customer receives order.
                        <div class="mt-3">
                          <div class="form-group">
                            <label class="control-label" for="days">Days</label>
                            <input type="text" id="days" [(ngModel)]="day.config"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"
                                   [ngModelOptions]="{standalone: true}" requiredclass="form-control" maxlength="2"
                                   min="0"
                                   max="60" required>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12">
                <div class="inner-box">
                  <h2>Reason For Product Return</h2>
                  <div class="row mt-3">
                    <div class="col">
                      <table class="table table-stripe">
                        <thead>
                        <tr>
                          <th class="w-25 p-l-0">Reason</th>
                          <th class="w-25">Action</th>
                        </tr>

                        <tr>
                          <td><input type="text" id="config" [(ngModel)]="config" class="form-control"
                                     (blur)="typeReason()" [ngClass]="{'is-invalid':statusText1}"
                                     [ngModelOptions]="{standalone: true}" required></td>
                          <td>
                            <a (click)="submitReturn()" data-toggle="modal" class="p-2 ml-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                                <defs>
                                  <style>.ab {
                                    fill: #ee7125;
                                  }</style>
                                </defs>
                                <path class="ab"
                                      d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                                      transform="translate(-3.375 -3.375)"/>
                              </svg>
                            </a>
                          </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let r of reasonList">
                          <td class="p-l-0">{{r.config}}</td>
                          <td>
                            <a data-toggle="modal" data-target="#deleteReturnModal1" (click)="selectedDeleteReturn(r)"
                               class="p-2 ml-3">
                              <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                                <defs>
                                  <style>.a {
                                    fill: #848484;
                                  }</style>
                                </defs>
                                <path class="a"
                                      d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                      transform="translate(-7.5 -4.5)"/>
                              </svg>
                            </a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <div id="statusText1" class="invalid-feedback d-block shift-invalid-login mt-2"
                           [hidden]="!statusText1">{{statusText1}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col">
                <div class="inner-box">
                  <h2>Non Returnable Items</h2>
                  <div class="row mt-3">
                    <div class="col">
                      <table class="table table-stripe">
                        <thead>
                        <tr>
                          <th class="w-25 p-l-0">Product Name</th>
                          <th class="w-25">Action</th>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-group mb-2 ware-house">
                              <ng-select id="product" [(ngModel)]="activeProduct"
                                         [ngClass]="{'service-error':statusText2}" (blur)="selectProduct()"
                                         [ngModelOptions]="{standalone: true}" required
                                         [items]="activeProducts"
                                         bindLabel="productName"
                                         placeholder="Products">
                              </ng-select>
                            </div>
                          </td>
                          <td>
                            <a data-toggle="modal" (click)="submitProduct()" class="p-2 ml-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                                <defs>
                                  <style>.ab {
                                    fill: #ee7125;
                                  }</style>
                                </defs>
                                <path class="ab"
                                      d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                                      transform="translate(-3.375 -3.375)"/>
                              </svg>
                            </a>
                          </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let rp of returnProducts">
                          <td class="p-l-0">{{rp.productName}}</td>
                          <td>
                            <a data-toggle="modal" data-target="#deleteReturnModal2" (click)="selectedDeleteProduct(rp)"
                               class="p-2 ml-3">
                              <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                                <defs>
                                  <style>.a {
                                    fill: #848484;
                                  }</style>
                                </defs>
                                <path class="a"
                                      d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                      transform="translate(-7.5 -4.5)"/>
                              </svg>
                            </a>
                          </td>
                        </tr>
                        <div id="statusText2" class="invalid-feedback d-block shift-invalid-login mt-2"
                             [hidden]="!statusText2">{{statusText2}}</div>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-btn-section">
                <div class="row">
                  <div class="col-12 text-right">
                    <button type="submit" (click)="submitDay(day)" class="btn btn-orange ml-2">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>

        <!--Delete model-box One-->
        <div class="container">
          <div class="modal fade" id="deleteReturnModal1" role="dialog">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Delete</h4>
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                  <p>Do you really want to delete </p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
                  <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteReturn()">Yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Delete model-box two-->
        <div class="container">
          <div class="modal fade" id="deleteReturnModal2" role="dialog">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Return Type</h4>
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                  <p>Do you really want to Change the Return Type </p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
                  <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="changeReturnProduct()">Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-btn-section" style="margin-left: -30px;">
        <div class="row">
          <div class="col-12 text-right">
            <button type="submit" (click)="submitDay(day)" class="btn btn-orange ml-2">Save</button>
          </div>
        </div>
      </div>

    </div>
    <div class="hide-sec" [ngClass]="{'show-sec': tabClicked === 'passwordManagement'}">
      <div class="inner-box">

        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="currentPassword">Current Password</label>
              <input type="password" id="currentPassword" maxlength="50" [(ngModel)]="currentPassword"
                     class="form-control"
                     (blur)="typeCurrentPwd()" [ngClass]="{'is-invalid':currentPwdError}"
                     [ngModelOptions]="{standalone: true}" required>
              <div id="currentPwdError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!currentPwdError">{{currentPwdError}}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="newPassword">New Password</label>
              <input type="password" id="newPassword" maxlength="50" [(ngModel)]="newPassword" class="form-control"
                     (blur)="typeNewPwd()" [ngClass]="{'is-invalid':newPwdError}" [ngModelOptions]="{standalone: true}"
                     required>
              <div id="newPwdError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!newPwdError">
                {{newPwdError}}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="confirmPassword">Confirm Password</label>
              <input type="password" id="confirmPassword" maxlength="50" [(ngModel)]="confirmPassword"
                     class="form-control"
                     (blur)="typeConfirmPwd()" [ngClass]="{'is-invalid':confirmPwdError}"
                     [ngModelOptions]="{standalone: true}" required>
              <div id="confirmPwdError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!confirmPwdError">{{confirmPwdError}}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col text-right">
            <button type="button" (click)="submitChangePassword()" id="change" class="btn btn-orange">Change</button>
          </div>
        </div>

      </div>
    </div>
    <div class="hide-sec" [ngClass]="{'show-sec': tabClicked === 'storeDetails'}">
      <div class="inner-box">

        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="sellerId">Seller ID</label>
              <input type="text" id="sellerId" [(ngModel)]="sellerDetail.sellerId" class="form-control"
                     [ngModelOptions]="{standalone: true}" disabled>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group">
              <label class="control-label" for="email">Email Address</label>
              <input type="text" id="email" maxlength="50" [(ngModel)]="sellerDetail.emailAddress" class="form-control"
                     (blur)="typeEmail()" [ngClass]="{'is-invalid':emailError}" [ngModelOptions]="{standalone: true}"
                     required>
              <div id="emailError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!emailError">
                {{emailError}}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="password">Password</label>
              <input type="password" id="password" maxlength="50" [(ngModel)]="sellerDetail.password"
                     class="form-control"
                     (blur)="typePwd()" [ngClass]="{'is-invalid':pwdError}"
                     [ngModelOptions]="{standalone: true}" required>
              <div id="pwdError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!pwdError">{{pwdError}}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col text-right">
            <button type="button" (click)="saveChange()" id="save" class="btn btn-orange">Save</button>
          </div>
        </div>

      </div>
    </div>
    <div class="hide-sec" [ngClass]="{'show-sec': tabClicked === 'notifications'}">
      <div class="row mb-5">
        <div class="col-6">
          <div class="inner-box"
               *ngFor="let notification of notificationsList">
            <table class="table">
              <thead>
              <tr>
                <th width="25%">Email/SMS</th>
                <th>{{notification.groupName}}</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let n of notification?.notificationTypes">
                <td width="25%">
                  <div class="toggle-2">
                    <input type="checkbox" name="onoffswitch" id="{{n.typeName}}" class="custom-control-input"
                           [(ngModel)]="n.enabled" [ngModelOptions]="{standalone: true}"
                           (change)="updateStatus(n,notification.id)" class="checkbox"/>
                    <label for="{{n.typeName}}" class="toggle">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </td>
                <td>{{n?.typeName}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </form>
</section>


